<template>
  <v-container class="modern-master-view pb-12">
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white">fas fa-chart-line</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text lh-1">Post Costeo de OTs</div>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest mt-1">Análisis de rentabilidad y costos reales</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center gap-3">
        <export-post-cost :filter="filter" :options="options" :disabled="loading" :search="search"/>
      </div>
    </v-row>

    <!-- Filters Section -->
    <v-card outlined class="modern-card pa-6 mb-8 shadow-sm">
      <v-row dense align="center">
        <v-col cols="12" md="2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Desde</div>
          <v-text-field 
            v-model='filter.created_after' 
            outlined dense hide-details clearable type="date"
            class="modern-input"
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" md="2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Hasta</div>
          <v-text-field 
            v-model='filter.created_before' 
            outlined dense hide-details clearable type="date"
            class="modern-input"
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Cliente</div>
          <customer-complete2 
            v-model="filter.customer" 
            @change="()=>{options.page=1;fetch()}"
            :disabled="loading"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Vendedor</div>
          <v-select
            v-model="filter.seller"
            :items="sellers"
            item-text="email"
            item-value="id"
            placeholder="Todos los vendedores"
            outlined dense hide-details clearable
            class="modern-input"
            prepend-inner-icon="fas fa-user-tie"
            @change="()=>{options.page=1;fetch()}"
          >
            <template v-slot:selection="{ item }">
              <span class="body-2 font-weight-bold">{{ item.first_name }} {{ item.last_name }}</span>
            </template>
            <template v-slot:item="{ item }">
              <div class="pa-1">
                <div class="body-2 font-weight-black">{{ item.first_name }} {{ item.last_name }}</div>
                <div class="caption grey--text">{{ item.email }}</div>
              </div>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" md="3">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-1 ml-1">Tipo de Orden</div>
          <v-select
            v-model="filter.reposicion"
            :items="reposicionOptions"
            item-text="text"
            item-value="value"
            placeholder="Todas"
            outlined dense hide-details clearable
            class="modern-input"
            @change="()=>{options.page=1;fetch()}"
          />
        </v-col>
        <v-col cols="12" md="auto" class="d-flex align-end pb-1 ml-auto">
          <v-btn color="primary" icon class="grey lighten-4 shadow-xs" @click="fetch" :loading="loading">
            <v-icon small>fas fa-sync</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Metrics Summary -->
    <!-- <v-row class="mb-8 px-4" v-if="workOrders.length > 0">
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card pa-6 border-left-primary h-100">
          <div class="caption font-weight-black text-uppercase tracking-widest grey--text mb-1">Monto Total Venta</div>
          <div class="text-h5 font-weight-black primary--text">{{ (total_sales || 0) | moneda }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card pa-6 border-left-success h-100">
          <div class="caption font-weight-black text-uppercase tracking-widest grey--text mb-1">Costo Real Total</div>
          <div class="text-h5 font-weight-black success--text">{{ (total_real || 0) | moneda }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card pa-6 h-100" :class="(real_margin || 0) > 0.3 ? 'border-left-success' : 'border-left-warning'">
          <div class="caption font-weight-black text-uppercase tracking-widest grey--text mb-1">Margen Real Promedio</div>
          <div class="text-h5 font-weight-black" :class="(real_margin || 0) > 0.3 ? 'success--text' : 'orange--text'">{{ (real_margin || 0) | percent(1) }}</div>
        </v-card>
      </v-col>
    </v-row> -->

    <!-- Main Table Card -->
    <v-card outlined class="modern-card overflow-hidden shadow-sm">
      <v-data-table
        :headers="headers"
        :items="workOrders"
        :options.sync="options"
        :server-items-length="totalWorkOrders"
        :loading="loading"
        class="modern-table"
        @update:options="fetch"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50, 100],
        }"
      >
        <!-- Integrated Search Slot -->
        <template v-slot:top>
          <v-sheet color="lightgrey" class="px-6 py-4 d-flex align-center border-bottom bg-lightgrey">
            <span class="caption font-weight-black uppercase tracking-widest grey--text">Ordenes de Trabajo Finalizadas: {{ totalWorkOrders }}</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              @keyup="searchTimeOut"
              placeholder="Buscar por OT, cliente o proyecto..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details clearable
              :disabled="loading"
              class="modern-search-field"
            ></v-text-field>
          </v-sheet>
        </template>

        <!-- Cell Templates -->
        <template v-slot:item.id="{ item }">
          <show-work-order :work_order_id="item.id">
            <div class="d-flex align-center py-2">
              <v-avatar size="32" color="primary lighten-5" class="mr-2">
                <span class="caption font-weight-black primary--text">OT</span>
              </v-avatar>
              <span class="body-2 font-weight-black primary--text">#{{ item.id }}</span>
            </div>
          </show-work-order>
        </template>

        <template v-slot:item.created_at="{ item }">
          <div class="d-flex flex-column py-2">
            <span class="caption grey--text font-weight-bold d-flex align-center mb-1">
              <v-icon x-small class="mr-1" color="grey lighten-1">fas fa-plus</v-icon>
              {{ item.created_at | moment("DD/MM/YYYY") }}
            </span>
            <span class="caption success--text font-weight-black d-flex align-center">
              <v-icon x-small class="mr-1" color="success">fas fa-check-double</v-icon>
              {{ item.completed_at | moment("DD/MM/YYYY") }}
            </span>
          </div>
        </template>

        <template v-slot:item.sales_note__name="{item}">
          <div class="d-flex flex-column py-2">
            <span class="body-2 font-weight-bold grey--text text--darken-4 lh-1-2 mb-1">{{ item.name }}</span>
            <div class="d-flex align-center" v-if="item.sales_note">
              <v-icon x-small color="grey lighten-1" class="mr-1">fas fa-file-invoice</v-icon>
              <span class="caption grey--text font-weight-bold">CN #{{ item.sales_note }}</span>
            </div>
          </div>
        </template>

        <template v-slot:item.sales_note__customer__name="{item}">
          <div class="d-flex flex-column py-2">
            <span class="caption font-weight-black secondary--text uppercase mb-1">{{ item.customer_name }}</span>
            <div class="d-flex align-center">
              <v-avatar size="18" color="grey lighten-4" class="mr-1 text-center">
                <v-icon color="grey darken-1" style="font-size: 10px">fas fa-user-tie</v-icon>
              </v-avatar>
              <span class="caption grey--text opacity-60 font-weight-bold">{{ item.seller_full_name }}</span>
            </div>
          </div>
        </template>

        <template v-slot:item.total_sale="{ item }">
          <span class="body-1 font-weight-black primary--text tracking-tighter">
            {{ (item.total_sale || (item.real_price && item.real_price.sales_total) || 0) | moneda }}
          </span>
        </template>

        <template v-slot:item.estimated_cost="{ item }">
          <div class="d-flex flex-column align-end py-2">
            <span class="body-2 font-weight-bold grey--text text--darken-2">{{ (item.estimated_cost || (item.real_price && item.real_price.sales_cost) || 0) | moneda }}</span>
            <v-chip x-small label class="font-weight-black mt-1 px-1">
              {{ (item.estimated_margin || 0) | percent(1) }} Margen
            </v-chip>
          </div>
        </template>

        <template v-slot:item.real_price="{ item }">
          <div class="d-flex flex-column align-end py-2">
            <span class="body-2 font-weight-black" :class="(item.real_margin || 0) < 0.2 ? 'error--text' : 'success--text'">
              {{ (item.real_cost || (item.real_price && (typeof item.real_price === 'object' ? item.real_price.total : item.real_price)) || 0) | moneda }}
            </span>
            <v-chip x-small label :color="(item.real_margin || 0) < 0.2 ? 'error lighten-5' : 'success lighten-5'" :class="(item.real_margin || 0) < 0.2 ? 'error--text' : 'success--text'" class="font-weight-black mt-1 px-1">
              {{ (item.real_margin || 0) | percent(1) }} Margen
            </v-chip>
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <v-btn fab x-small depressed color="primary" class="shadow-sm" @click="openDetail(item)">
              <v-icon small>fas fa-eye</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showDetail" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <detailed-post-cost
        v-if="showDetail && detailOtId"
        :work_order_id="detailOtId"
        @close="showDetail=false"
      />
    </v-dialog>

    <v-dialog v-model="display" max-width="1200" content-class="modern-dialog">
      <work-order-card :work_order='workOrderOnDisplay' @close="display=false"/>
    </v-dialog>
  </v-container>
</template>

<script>
import { fetchPostCostWorkOrders } from '@/api/reports'
import CustomerComplete2 from '@/components/customers/CustomerComplete2.vue'
import WorkOrderCard from '@/components/production/WorkOrderCard'
import ShowWorkOrder from '@/components/production/ShowWorkOrder'
import ExportPostCost from '@/components/reports/ExportPostCost'
import DetailedPostCost from '@/views/Reports/DetailedPostCost.vue'
import moment from 'moment'
import notifications from '@/utils/notifications'

export default {
  name: 'PostCostWorkOrders',
  components: {
    CustomerComplete2,
    WorkOrderCard,
    ShowWorkOrder,
    ExportPostCost,
    DetailedPostCost
  },
  
  data() {
    return {
      loading: false,
      reposicionOptions: [
        { text: 'Reposición', value: 'true' },
        { text: 'Normal', value: 'false' },
      ],
      filter: {
        created_after: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD'),
        created_before: '',
        customer: '',
        seller: '',
        reposicion: '',
      },
      showDetail: false,
      detailOtId: null,
      workOrderOnDisplay: {},
      options: {},
      totalWorkOrders: 0,
      display: false,
      search: '',
      workOrders: [],
      estimated_margin: '',
      real_margin: '',
      total_sales: '',
      total_estimated: '',
      total_real: '',
      sellers: [],
      timer: null,
      headers: [
        { text: 'Orden de Trabajo', align: 'start', value: 'id', class: 'table-header', width: '160px' },
        { text: 'Fechas (In/Out)', align: 'start', value: 'created_at', class: 'table-header', width: '140px' },
        { text: 'Proyecto / Referencia', align: 'start', value: 'sales_note__name', class: 'table-header' },
        { text: 'Cliente / Vendedor', align: 'start', value: 'sales_note__customer__name', class: 'table-header' },
        { text: 'Precio Venta', align: 'end', value: 'total_sale', class: 'table-header', sortable: false, width: '140px' },
        { text: 'Costo Teórico', align: 'end', value: 'estimated_cost', class: 'table-header', sortable: false, width: '140px' },
        { text: 'Costo Real', align: 'end', value: 'real_price', class: 'table-header', sortable: false, width: '140px' },
        { text: '', align: 'center', value: 'actions', class: 'table-header', sortable: false, width: '60px' }
      ],
    }
  },
  
  methods: {
    async fetch() {
      this.loading = true
      
      let created_before = ''
      let created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('YYYY-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('YYYY-MM-DD HH:mm')
      
      const customerId = this.filter.customer?.id || ''
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      
      let ordering = '-id'
      if (sortBy && sortBy.length > 0) {
        ordering = sortDesc[0] ? sortBy[0] : '-' + sortBy[0]
      }
      
      const query = `ordering=${ordering}&page=${page || 1}&page_size=${itemsPerPage || 20}&search=${this.search}&created_after=${created_after}&created_before=${created_before}&sales_note__customer=${customerId}&sales_note__customer__seller=${this.filter.seller || ''}&completed=true&sales_note__reposicion=${this.filter.reposicion || ''}`
      
      try {
        const data = await fetchPostCostWorkOrders(query)
        this.totalWorkOrders = data.count
        this.workOrders = data.results.map(item => {
          // Robust mapping of real_price object
          const rp = item.real_price || {}
          const sales_cost = rp.sales_cost || 0
          const sales_total = rp.sales_total || 0
          const total = rp.total || 0
          
          item.estimated_margin = sales_total != 0 ? (1 - sales_cost / sales_total) : 0
          item.real_margin = sales_total != 0 ? (1 - total / sales_total) : 0
          return item
        })
        this.total_sales = data.total_sales
        this.total_real = data.total_real
        this.total_estimated = data.total_estimated
        this.estimated_margin = data.estimated_margin
        this.real_margin = data.real_margin
      } catch (err) {
        notifications.showError('Error cargando OTs: ' + err)
      } finally {
        this.loading = false
      }
    },
    
    openDetail(item) {
      this.detailOtId = item.id
      this.showDetail = true
    },

    searchTimeOut() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.options.page = 1
        this.fetch()
      }, 800)
    }
  },
  
  async mounted() {
    this.sellers = await this.$store.getters.getSellers
    this.fetch()
  }
}
</script>

<style scoped>
.modern-master-view { background-color: #f4f7f9; min-height: 100vh; }
.modern-card { border-radius: 12px !important; border: 1px solid rgba(0,0,0,0.05) !important; background-color: white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; }
.shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; }
.border-white-sm { border: 2px solid white !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
.border-left-primary { border-left: 4px solid var(--v-primary-base) !important; }
.border-left-success { border-left: 4px solid var(--v-success-base) !important; }
.border-left-warning { border-left: 4px solid var(--v-warning-base) !important; }
.bg-lightgrey { background-color: #f8fbfc; }
.lh-1 { line-height: 1 !important; }
.lh-1-2 { line-height: 1.2 !important; }
.gap-3 { gap: 12px; }
.uppercase { text-transform: uppercase; }
.tracking-widest { letter-spacing: 1.8px; }
.tracking-tighter { letter-spacing: -0.5px; }
.h-44 { height: 44px !important; }
.opacity-60 { opacity: 0.6; }

.modern-input >>> fieldset { border-radius: 8px !important; border-color: #e0e4e8 !important; }
.modern-search-field { width: 320px; }
.modern-search-field >>> fieldset { border-radius: 24px !important; border-color: #e0e4e8 !important; }

.modern-table >>> thead th { background-color: #f8fbfc !important; height: 56px !important; text-transform: uppercase; font-size: 0.75rem !important; letter-spacing: 1px; font-weight: 900 !important; color: #607d8b !important; }
.modern-table >>> td { height: 72px !important; border-bottom: 1px solid #f0f3f5 !important; }
.modern-table >>> tr:hover { background-color: #f4f7f9 !important; }
</style>
